import { FC, useEffect } from 'react'
import { WithPostUid, CommentUid, FeedOrdering, PostUid, FEED_ORDERING_CHRONOLOGICALLY } from 'interfaces/feed'
import { getCommentsActionCreator } from 'actions/feedActions'
import { ViewCommentCTA } from 'interfaces/insights'
import { GetCommentsPayload } from 'actions/feedActions'
import { extractAllGetParams } from 'helpers/utilsHelpers'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import useRouter from 'use-react-router'

type GetCommentsRequestPayloadArg = {
  urlPostUid?: PostUid
  urlCommentUid?: CommentUid
  urlCommentsOrdering?: FeedOrdering

  insightCta: ViewCommentCTA | null

  postUid: PostUid
}
const getCommentsRequestPayload = (params: GetCommentsRequestPayloadArg): GetCommentsPayload | null => {
  const {
    urlPostUid,
    urlCommentUid,
    urlCommentsOrdering,
    insightCta,
    postUid,
  } = params

  // insight cta have more priority over params passed via url
  if (insightCta && insightCta.post_uid === postUid) {
    return {
      postUid,
      ordering: FEED_ORDERING_CHRONOLOGICALLY,
      highlightCommentUid: insightCta.comment_uid,
    }
  }

  if (urlCommentUid && urlPostUid === postUid) {
    return {
      postUid,
      ordering: urlCommentsOrdering,
      highlightCommentUid: urlCommentUid,
    }
  }

  return null
}

type CommentListLoadingHandlerProps =
  & WithPostUid

export const CommentListLoadingHandler: FC<CommentListLoadingHandlerProps> = (props) => {
  const { postUid } = props

  const { location, match } = useRouter<WithPostUid>()
  const getParams = extractAllGetParams(location.search)
  const { postUid: urlPostUid } = match.params

  const urlCommentUid = getParams['comment_uid']
  const urlCommentsOrdering: FeedOrdering = getParams['comments_ordering'] as FeedOrdering

  const insightViewCommentCta = useStoreSelector((state) => state.app.feed.targetComment)
  const dispatch = useStoreDispatch()

  useEffect(() => {
    const payload = getCommentsRequestPayload({
      urlPostUid,
      urlCommentUid,
      urlCommentsOrdering,
      insightCta: insightViewCommentCta,
      postUid,
    })

    if (!payload) {
      return
    }

    dispatch(getCommentsActionCreator.request(payload))

  }, [dispatch, insightViewCommentCta, postUid, urlCommentUid, urlCommentsOrdering, urlPostUid])

  return (
    <></>
  )
}
